import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

type CellRendererFunc = (params: ICellRendererParams) => string | React.ReactElement | null;

interface CellRendererParams {
  params: ICellRendererParams;
  renderer: string | React.ReactElement | CellRendererFunc | null;
}

export const cellRenderer = ({ params, renderer }: CellRendererParams) => {
  if (typeof renderer === 'function') {
    return renderer(params) || null;
  }
  return renderer || null;
};
